import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter, forwardRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import moment from 'moment';

import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvMessageComponent, MarvTagComponent } from '@marv/components';
import { MarvDateService } from '@marv/services';
import { MissionItem, PlanningItem, PlanningItemComponent } from '@app/components';
import { MissionTypeService } from '@app/services';

class DayOperation {
    id: number;
    name: string;
    typeOfMission: string;
    source: string;
    nbMissions: number;
}

class Day {   
    date: Date;
    planningItems: Array<PlanningItem>;
    operations: Array<DayOperation>;
    today?: boolean;
}

@Component({
    selector: 'app-planning-week',
    templateUrl: './week.component.html',
    styleUrls: ['./week.component.scss'],
    imports: [
        TranslatePipe, 
        forwardRef(() => MarvMessageComponent), forwardRef(() => MarvTagComponent), forwardRef(() => MarvDateToStringPipe), forwardRef(() => PlanningItemComponent)
    ]
})
export class PlanningWeekComponent  implements OnInit {

    @Input({alias : 'missions', required : true}) missionsItems: Array<MissionItem> = [];
    @Input({alias : 'startDate', required : true}) startDate: Date;
    @Input({alias : 'endDate', required : true}) endDate: Date;
    @Input({alias : 'weekDays', required : false}) weekDays: Array<number>|undefined;
    @Output() onSelectMission = new EventEmitter<MissionItem>();

    isFetching: boolean = false; 
    days: Array<Day> = [];

    constructor(
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes['missionsItems']){
            this.displayPlanning();
        }
    }
    
    displayPlanning(){
        this.isFetching = true;
        this.days = [];
        let days: Array<Day> = [];
        
        let cpt = 1;
        let now = new Date();
        let day = moment(MarvDateService.GetFirstDayOfWeek(this.startDate));
        let endDate = moment(MarvDateService.GetLastDayOfWeek(this.startDate));
        while (day <= endDate && cpt <= 8){  
        
            if(!this.weekDays || this.weekDays.indexOf(parseInt(day.format('E'))) !== -1){  
            
                let dayOperations: Array<DayOperation> = [];
                let daysMissions: Array<MissionItem> = this.missionsItems.filter(m => {
                    let mDay = MarvDateService.ToDate(m.day)
                    return (mDay && moment(mDay).format('YYYY-MM-DD') ===  day.format('YYYY-MM-DD'));
                });
                
                for(let dm of daysMissions){                    
                    let existOp = dayOperations.find(dop => dop.id === dm.operation.id && dm.operation.source === dop.source);
                    if(existOp){
                        existOp.nbMissions++;
                    }
                    else{
                        dayOperations.push({
                            id: dm.operation.id,
                            name: dm.operation.name,
                            typeOfMission: dm.operation.typeOfMission,
                            source: dm.operation.source,
                            nbMissions: 1
                        });
                    }
                }

                days.push({                
                    date: day.toDate(),
                    planningItems: this.fromMissionsItems(daysMissions),
                    operations: dayOperations,
                    today: (moment(now).format('YYYY-MM-DD') ===  day.format('YYYY-MM-DD'))
                });
            }
            
            day = day.add(1, 'day');
            cpt++;
        }
         
        this.days = days;
        this.isFetching = false;;
    }
    
    fromMissionsItems(missions: Array<MissionItem>): Array<PlanningItem> {
        let planningItems: Array<PlanningItem> = [];
        for(let m of missions){
            planningItems.push(PlanningItem.FromMissionItem(m, 'week'));
        }
        return planningItems;
    }
    
    selectPlanningItem(planningItem: PlanningItem){
        let missionItem = this.missionsItems.find(m => m.activityId === planningItem.activityId && m.source == planningItem.source);
        if(missionItem){
            this.onSelectMission.emit(missionItem);
        }
    }

}
